export default __webpack_public_path__ + "static/media/thonk.92bb1f40.jpg";